import {
    FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT,
    FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_SUCCESS,
    FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_ERROR,
    RESET_ADAPTIVE_PLAN_NEXT_WORKOUT,
    FETCHING_ADAPTIVE_PLAN_NEXT_WORKOUT
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    fetching: false,
    hasFetched: false,
    error: false,
    entity: {}
};

const receiveAdaptivePlanNextWorkoutError = (state, action) => {
    return {
        fetching: false,
        error: true,
        hasFetched: false,
        entity: {
            ...action.atpNextWorkout,
            ...action.atpWorkout
        }
    };
};

const receiveAdaptivePlanNextWorkout = (state, action) => {
    return {
        fetching: false,
        error: false,
        hasFetched: true,
        entity: {
            ...action.atpNextWorkout,
            ...action.atpWorkout
        }
    };
};

const fetchingAdaptivePlanNextWorkout = (state, action) => {
    return {
        ...state,
        fetching: true,
        hasFetched: false
    };
};

const resettingAdaptivePlanNextWorkout = () => {
    return INITIAL_STATE;
};

const handlers = {
    [RESET_ADAPTIVE_PLAN_NEXT_WORKOUT]: resettingAdaptivePlanNextWorkout,
    [FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_SUCCESS]: receiveAdaptivePlanNextWorkout,
    [FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_ERROR]: receiveAdaptivePlanNextWorkoutError,
    [FETCHING_ADAPTIVE_PLAN_NEXT_WORKOUT]: fetchingAdaptivePlanNextWorkout
};

export const getATPNextWorkout = (state) => state.atpNextWorkout.entity;
export const isNextWorkoutError = (state) => state.atpNextWorkout.error;
export const hasNextWorkoutFetched = (state) => {
    return state.atpNextWorkout.hasFetched;
};
export const isFetchingNextWorkout = (state) => state.atpNextWorkout.fetching;

export default function atpNextWorkout(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchAdaptivePlanNextWorkout(athletePlanId) {
    return {
        type: FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT,
        payload: {
            athletePlanId
        }
    };
}

export function resetAdaptivePlanNextWorkout() {
    return {
        type: RESET_ADAPTIVE_PLAN_NEXT_WORKOUT
    };
}
